import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Sidebar = ({ onLogout, onClose }) => {
  const location = useLocation();
  
  const navItems = [
    { path: '/dashboard', label: 'Dashboard', icon: 'dashboard' },
    { path: '/profile', label: 'Profile', icon: 'person' },
    { path: '/user-pricing', label: 'Upgrade Plan', icon: 'star' },
    { path: '/payment-history', label: 'Payment History', icon: 'receipt' },
    { path: '/settings', label: 'Settings', icon: 'settings' },
  ];
  
  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/');
  
  return (
    <div className="w-64 bg-[#0a0f1e] min-h-screen flex flex-col safe-area-top relative overflow-hidden">
      {/* Subtle background texture */}
      <div className="absolute inset-0 opacity-[0.02]" style={{ backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)', backgroundSize: '20px 20px' }} />
      {/* Ambient glow */}
      <div className="absolute -top-20 -left-10 w-40 h-40 bg-emerald-500/5 rounded-full blur-3xl pointer-events-none" />

      {/* Logo */}
      <div className="relative p-6 safe-area-top sticky top-0 z-40 bg-[#0a0f1e]">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="site-logo relative">
              <div className="absolute inset-0 bg-emerald-500/20 rounded-lg blur-md" />
              <img src="/logo-icon.png" alt="SiteScope Logo" className="w-10 h-10 relative" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-white tracking-tight">SiteScope</h1>
              <p className="text-emerald-400/60 text-xs font-medium">24/7 Website Monitoring</p>
            </div>
          </div>
          <button 
            className="md:hidden p-2 hover:bg-white/5 rounded-lg transition-colors"
            onClick={onClose}
            aria-label="Close menu"
          >
            <span className="material-icons text-white">close</span>
          </button>
        </div>
        {/* Gradient divider */}
        <div className="mt-6 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
      </div>
      
      {/* Navigation */}
      <nav className="relative flex-1 px-3 py-2">
        <ul className="space-y-1">
          {navItems.map((item) => (
            <li key={item.path}>
              <Link
                to={item.path}
                onClick={onClose}
                className={`flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm transition-all duration-200 ${
                  isActive(item.path)
                    ? 'bg-emerald-500/10 text-emerald-400 font-semibold border-l-[3px] border-emerald-400 ml-0 pl-[13px]'
                    : 'text-gray-400 hover:bg-white/5 hover:text-white border-l-[3px] border-transparent ml-0 pl-[13px]'
                }`}
              >
                <span className={`material-icons text-lg ${isActive(item.path) ? 'text-emerald-400' : ''}`}>{item.icon}</span>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      
      {/* Logout */}
      <div className="relative px-3 pb-4 pt-2">
        <div className="mb-3 h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
        <button
          onClick={onLogout}
          className="w-full flex items-center gap-3 px-4 py-2.5 rounded-xl text-sm text-gray-400 hover:bg-red-500/10 hover:text-red-400 transition-all duration-200"
        >
          <span className="material-icons text-lg">logout</span>
          Logout
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
